import { get, post, remove } from './api.js'

export function callCheckForUpdates(tenantId) {
  return get(`/api/auth/updates-count/${tenantId}`)
}

export function callGetPost(id) {
  return get(`/api/post/${id}`)
}

export function callGetHomePosts(payload) {
  return post('/api/home-posts', payload)
}

// @TODO id param in request path
export function callUpdatePost(payload) {
  return post(`/api/auth/update-post`, payload)
}

export function callDeletePost(id) {
  return get(`/api/auth/delete-post/${id}`)
}

export function callGetCloudPost(id) {
  return get(`/api/cloudpost/${id}`)
}

export function callSaveCloudpage(payload) {
  return post('/api/auth/manager-cloud-post-save', payload)
}

export function callGetLibraryPosts(payload) {
  return post('/api/auth/manager-library-pages', payload)
}

export function callGetCloudPosts(payload) {
  return post('/api/auth/manager-cloud-posts', payload)
}

export function callLogPostView(payload) {
  return post('/api/log-post-view', payload)
}

export function callLogCTAClick(payload) {
  return post('/api/log-post-cta-click', payload)
}

export function callSendContactForm(payload) {
  return post('/api/send-contact-form', payload)
}

export function callUpsertAdmin(payload) {
  return post('/api/auth/upsert-admin', payload)
}

export function callDeleteAdmin(id) {
  return remove(`/api/auth/delete-admin/${id}`)
}

export function callSendNewsletterSignUp(payload) {
  return post('/api/request-subscription', payload)
}

export function callUpdateAutoNewsletter(payload) {
  return post('/api/auth/update-auto-newsletter', payload)
}

export function callTurnOffAutoNewsletter() {
  return get('/api/auth/turn-off-auto-newsletter')
}

export function callGetAutoNewsletterStatus() {
  return get('/api/auth/get-auto-newsletter-status')
}

export function updateCloudAutoModeStatus(payload) {
  return post('/api/auth/update-cloud-auto-mode-status', payload)
}

export function callGetSchools() {
  return get(`/api/get-schools`)
}

export function callSendConnectionParentRegistration(payload) {
  return post(`/api/cw-connection-parent-registration`, payload)
}
